/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Not_TrackableInputs */

const en_error_inbound_not_trackable = /** @type {(inputs: Error_Inbound_Not_TrackableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tracking of this inbound can be written only while it is on its way to the warehouse: from its submission until the warehouse receives it.`)
};

/**
* | output |
* | --- |
* | "The tracking of this inbound can be written only while it is on its way to the warehouse: from its submission until the warehouse receives it." |
*
* @param {Error_Inbound_Not_TrackableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_not_trackable = /** @type {((inputs?: Error_Inbound_Not_TrackableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Not_TrackableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_not_trackable(inputs)
});